import { html } from '@lit'

const chevron = html`
  <svg aria-hidden="true" focusable="false" fill="none" width="11" class="icon icon-chevron-right  icon--direction-aware"
    viewBox="0 0 10 10">
    <path d="m3 9 4-4-4-4" stroke="currentColor" stroke-linecap="square"></path>
  </svg>
`

const filter = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
    <line y1="3.75" x2="16" y2="3.75" stroke="currentColor" stroke-width="1.5"></line>
    <line y1="10.75" x2="16" y2="10.75" stroke="currentColor" stroke-width="1.5"></line>
    <circle cx="6.19922" cy="3.5" r="2.5" fill="white" stroke="currentColor"></circle>
    <circle cx="10.1992" cy="10.5" r="2.5" fill="white" stroke="currentColor"></circle>
  </svg>
`

const close = html`
  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" fill="none" viewBox="0 0 18 17">
    <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z"
      fill="currentColor">
  </svg>
`
const caret = html`
  <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"
      fill="currentColor">
  </svg>
`
const play = html`
  <svg width="30" height="31" viewBox="0 0 30 31" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M28.9922 15.8999L4.25 30.0383L4.25 1.76149L28.9922 15.8999Z" />
  </svg>
`
const pause = html`
  <svg width="30" height="31" fill="currentColor" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
    <path d="M120.16 45A20.162 20.162 0 0 0 100 65.16v381.68A20.162 20.162 0 0 0 120.16 467h65.68A20.162 20.162 0 0 0 206 446.84V65.16A20.162 20.162 0 0 0 185.84 45h-65.68zm206 0A20.162 20.162 0 0 0 306 65.16v381.68A20.162 20.162 0 0 0 326.16 467h65.68A20.162 20.162 0 0 0 412 446.84V65.16A20.162 20.162 0 0 0 391.84 45h-65.68z"/>
  </svg>
`

const search = html`
  <svg aria-hidden="true" fill="none" focusable="false" width="24" viewBox="0 0 24 24">
    <path d="M10.364 3a7.364 7.364 0 1 0 0 14.727 7.364 7.364 0 0 0 0-14.727Z" stroke="currentColor" stroke-width="1" stroke-miterlimit="10"
    />
    <path d="M15.857 15.858 21 21.001" stroke="currentColor" stroke-width="1" stroke-miterlimit="10" stroke-linecap="round" />
  </svg>
`

const navigationArrow = html`
  <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon-arrow-right  icon--direction-aware" viewBox="0 0 16 18">
    <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"></path>
  </svg>
`

const plus = html`
  <svg aria-hidden="true" focusable="false" fill="none" width="10" viewBox="0 0 12 12">
    <path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="1" />
  </svg>
`

const minus = html`
  <svg aria-hidden="true" focusable="false" fill="none" width="10" viewBox="0 0 12 12">
    <path d="M0 6h12" stroke="currentColor" stroke-width="1" />
  </svg>
`

const edit = html`
  <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6238 3.2827L9.74983 0.871184L8.71632 2.10287L11.5903 4.51438L12.6238 3.2827ZM11.7955 4.68663L11.6233 4.89191L4.21649 13.719L4.04424 13.9243L3.98412 13.8738L1.20792 14.1167L1.07444 14.1284L1.06276 13.9949L0.819876 11.2187L0.759751 11.1682L0.932002 10.963L8.33879 2.1359L8.51104 1.93062L9.54455 0.698933L9.7168 0.493652L9.92208 0.665903L12.796 3.07742L13.0013 3.24967L12.829 3.45495L11.7955 4.68663ZM8.54407 2.30815L1.13728 11.1352L4.01121 13.5467L11.418 4.71966L8.54407 2.30815ZM1.31804 13.8381L1.11019 11.4623L3.6938 13.6302L1.31804 13.8381Z"
      fill="#55565A" stroke="#55565A" stroke-width="0.4" />
  </svg>
`

const deleteIcon = html`
  <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.4326 1L0.574219 10.8583L10.4326 1Z" stroke="#55565A" stroke-miterlimit="10" stroke-linecap="round" />
    <path d="M10.29 10.8583L0.431641 1L10.29 10.8583Z" stroke="#55565A" stroke-miterlimit="10" stroke-linecap="round" />
  </svg>
`

const heart = html`
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.41447 12.46L2.40878 12.4544L2.40419 12.4502C-0.136587 9.94345 -0.134729 5.88741 2.40976 3.38296L2.40984 3.38289C4.95942 0.87237 9.09844 0.87237 11.648 3.38289L11.9987 3.72818L12.3495 3.38304C14.9015 0.872238 19.0407 0.872452 21.5902 3.38289L21.5902 3.38296C24.1361 5.88875 24.1366 9.94778 21.5917 12.4542C21.5912 12.4547 21.5907 12.4552 21.5902 12.4556L21.5149 12.5285L21.5149 12.5285L21.5117 12.5316L12 21.8957L2.41447 12.46Z" stroke="black"/>
  </svg>
`

const audioOn = html`
<svg width="30" height="31" fill="currentColor" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path clip-rule="evenodd" d="M8.56581 6.77138C8.56581 3.58394 11.1852 1 14.4163 1C17.6474 1 20.2667 3.58394 20.2667 6.77138V12.5428C20.2667 15.7302 17.6474 18.3141 14.4163 18.3141C11.1852 18.3141 8.56581 15.7302 8.56581 12.5428V6.77138ZM14.4163 3.30855C12.4776 3.30855 10.906 4.85891 10.906 6.77138V12.5428C10.906 14.4552 12.4776 16.0056 14.4163 16.0056C16.3549 16.0056 17.9265 14.4552 17.9265 12.5428V6.77138C17.9265 4.85891 16.3549 3.30855 14.4163 3.30855Z" fill-rule="evenodd"/>
  <path d="M12.5039 24.8743C12.9457 24.8743 13.3039 24.5161 13.3039 24.0743V22.6464C8.4263 22.1156 4.55224 18.2986 4.0067 13.4892C3.93387 12.8471 4.46474 12.3211 5.11096 12.3211C5.75718 12.3211 6.27205 12.848 6.36576 13.4874C6.93878 17.3972 10.3496 20.401 14.4717 20.401C18.5937 20.401 22.0046 17.3972 22.5776 13.4874C22.6713 12.848 23.1862 12.3211 23.8324 12.3211C24.4786 12.3211 25.0095 12.8471 24.9367 13.4892C24.3913 18.2971 20.5195 22.1132 15.644 22.6459V24.0743C15.644 24.5161 16.0022 24.8743 16.444 24.8743H18.6747C19.1165 24.8743 19.4747 25.2324 19.4747 25.6743V26.3828C19.4747 26.8246 19.1165 27.1828 18.6747 27.1828H10.3272C9.88539 27.1828 9.52721 26.8246 9.52721 26.3828V25.6743C9.52721 25.2324 9.88538 24.8743 10.3272 24.8743H12.5039Z"/>
</svg>
`

const audioOff = html`
<svg width="30" height="31" fill="currentColor" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path clip-rule="evenodd" d="M19.5305 6.38229C19.4255 3.39197 16.9659 1 13.9471 1C10.8615 1 8.36015 3.49896 8.36015 6.58159V12.1632C8.36015 14.9547 10.4113 17.2675 13.0901 17.6795L12.0429 19.5164C9.02506 18.7397 6.71246 16.2088 6.25919 13.0768C6.16971 12.4584 5.67803 11.9488 5.06092 11.9488C4.4438 11.9488 3.93685 12.4575 4.0064 13.0785C4.45102 17.0481 7.21086 20.3186 10.9057 21.5111L8.5572 25.6306C8.33838 26.0145 8.47019 26.5064 8.8516 26.7294L9.12441 26.8889C9.50583 27.1119 9.99241 26.9816 10.2112 26.5977L23.7432 2.86133C23.962 2.47749 23.8302 1.98555 23.4488 1.76253L23.176 1.60302C22.7945 1.38001 22.308 1.51038 22.0891 1.89421L19.5305 6.38229ZM17.2992 10.2962V6.58159C17.2992 4.73202 15.7984 3.23264 13.9471 3.23264C12.0957 3.23264 10.5949 4.73202 10.5949 6.58159V12.1632C10.5949 14.0128 12.0957 15.5121 13.9471 15.5121C14.0795 15.5121 14.2101 15.5045 14.3385 15.4895L17.2992 10.2962Z" fill-rule="evenodd"/>
  <path d="M18.0137 26.3218H12.5766L16.5597 19.335C19.2794 18.3944 21.3182 15.9969 21.7408 13.0768C21.8303 12.4584 22.322 11.9488 22.9391 11.9488C23.5562 11.9488 24.0632 12.4575 23.9936 13.0785C23.4728 17.7283 19.7754 21.4189 15.1196 21.9341V23.3155C15.1196 23.7428 15.4616 24.0892 15.8835 24.0892H18.0137C18.4356 24.0892 18.7776 24.4356 18.7776 24.8629V25.5481C18.7776 25.9754 18.4356 26.3218 18.0137 26.3218Z"/>
</svg>
`

const captionsOn = html`
  <svg fill="currentColor" width="30" height="31" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-9 6H8v4h3v2H8c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h3v2zm7 0h-3v4h3v2h-3c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h3v2z"/>
  </svg>
`

const captionsOff = html`
  <svg fill="currentColor" width="30" height="31" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 10v4c0 1.103.897 2 2 2h3v-2H8v-4h3V8H8c-1.103 0-2 .897-2 2zm7 0v4c0 1.103.897 2 2 2h3v-2h-3v-4h3V8h-3c-1.103 0-2 .897-2 2z"/><path d="M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 18V6h16l.002 12H4z"/>
  </svg>
`

export {
  chevron,
  filter,
  close,
  caret,
  play,
  pause,
  search,
  navigationArrow,
  plus,
  minus,
  edit,
  deleteIcon,
  heart,
  audioOn,
  audioOff,
  captionsOn,
  captionsOff,
}
